
import { RouterModule, Routes } from '@angular/router';
import { NoAuthGuard } from '../auth/no-auth-guard.service';
import { ForgotpwdComponent } from './forgotpwd.component'
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule }   from '@angular/forms';
import {CommonModule} from '@angular/common';
import {AppRoutingModule} from '../app.routing'
import {NgxMaskModule} from 'ngx-mask';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}
@NgModule({
    imports: [
      AppRoutingModule,
      FormsModule,
      NgxMaskModule,
      CommonModule,
      HttpClientModule,
      TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }), 
    ],
    declarations: [
        ForgotpwdComponent
    ],
  
    providers: [
      NoAuthGuard
    ]
  })
export class ForgotpwdModule {}